/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserAuthenticationConstraint } from './UserAuthenticationConstraint';
import {
    UserAuthenticationConstraintFromJSON,
    UserAuthenticationConstraintFromJSONTyped,
    UserAuthenticationConstraintToJSON,
    UserAuthenticationConstraintToJSONTyped,
} from './UserAuthenticationConstraint';

/**
 * 
 * @export
 * @interface UserMigrationApplicationResponse
 */
export interface UserMigrationApplicationResponse {
    /**
     * 
     * @type {string}
     * @memberof UserMigrationApplicationResponse
     */
    applicationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserMigrationApplicationResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserMigrationApplicationResponse
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserMigrationApplicationResponse
     */
    url?: string | null;
    /**
     * 
     * @type {UserAuthenticationConstraint}
     * @memberof UserMigrationApplicationResponse
     */
    userAuthenticationConstraint?: UserAuthenticationConstraint;
}



/**
 * Check if a given object implements the UserMigrationApplicationResponse interface.
 */
export function instanceOfUserMigrationApplicationResponse(value: object): value is UserMigrationApplicationResponse {
    return true;
}

export function UserMigrationApplicationResponseFromJSON(json: any): UserMigrationApplicationResponse {
    return UserMigrationApplicationResponseFromJSONTyped(json, false);
}

export function UserMigrationApplicationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserMigrationApplicationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationId': json['applicationId'] === undefined ? undefined : json['applicationId'] === null ? null : json['applicationId'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'description': json['description'] === undefined ? undefined : json['description'] === null ? null : json['description'],
        'url': json['url'] === undefined ? undefined : json['url'] === null ? null : json['url'],
        'userAuthenticationConstraint': json['userAuthenticationConstraint'] == null ? undefined : UserAuthenticationConstraintFromJSON(json['userAuthenticationConstraint']),
    };
}

export function UserMigrationApplicationResponseToJSON(json: any): UserMigrationApplicationResponse {
    return UserMigrationApplicationResponseToJSONTyped(json, false);
}

export function UserMigrationApplicationResponseToJSONTyped(value?: UserMigrationApplicationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationId': value['applicationId'],
        'name': value['name'],
        'description': value['description'],
        'url': value['url'],
        'userAuthenticationConstraint': UserAuthenticationConstraintToJSON(value['userAuthenticationConstraint']),
    };
}

